import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { includes } from 'ramda'
import { Button, RadioButtonGroup } from 'components/patterns'
import { opMap, OPERATORS } from 'components/utils'
import strings from 'utils/strings'
import { BOOLEAN, INPUT, OUTPUT } from 'utils/constants'
import { Icon__Info as IconInfo } from 'components/patterns/Icon/components'
import { useHelpModal } from 'components/HelpModal'
import HelpContent from './HelpContent'

const allowableOperatorKeys = new Set([
  OPERATORS.EQUAL,
  OPERATORS.NOT_EQUAL,
  OPERATORS.LESS_THAN,
  OPERATORS.GREATER_THAN_OR_EQUAL,
])

const allowedBooleanValues = [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL]

const makeDisableOption = (isInput, translationType, equalsOnly, key) => {
  if (equalsOnly) {
    return key !== OPERATORS.EQUAL
  }
  if (isInput && translationType === BOOLEAN) {
    return !includes(key, allowedBooleanValues)
  }

  return false
}

const OperatorEditor = ({
  operator,
  onOperatorChange,
  translationType,
  operatorType,
  equalsOnly,
}) => {
  const { openModal } = useHelpModal()

  const isInput = operatorType === INPUT
  const disableOption = useCallback(
    (key) => makeDisableOption(isInput, translationType, equalsOnly, key),
    [isInput, translationType, equalsOnly]
  )

  const handleModal = () => {
    openModal(<HelpContent />)
  }

  return (
    <div>
      <RadioButtonGroup
        label={strings.input_operator}
        currentValue={operator}
        onChange={onOperatorChange}
        vertical
        buttons={Object.keys(opMap)
          .map((key) => parseInt(key, 10))
          .filter((key) => allowableOperatorKeys.has(key))
          .map((key) => ({
            key,
            value: key,
            text: opMap[key],
            disabled: disableOption(key),
          }))}
        radioGroupClassName="operator-radio-group"
      />
      <Button
        link
        onClick={handleModal}
        style={{ marginTop: 3, alignSelf: 'flex-start' }}
      >
        <IconInfo
          style={{ display: 'inline-block', verticalAlign: 'middle' }}
        />{' '}
        {strings.what_is_this}
      </Button>
    </div>
  )
}

OperatorEditor.defaultProps = {
  operatorType: OUTPUT,
}

OperatorEditor.propTypes = {
  operator: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onOperatorChange: PropTypes.func,
  translationType: PropTypes.string,
  operatorType: PropTypes.oneOf([INPUT, OUTPUT]),
  equalsOnly: PropTypes.bool,
}

export default OperatorEditor
